import { Loading03Icon } from '@hugeicons/react'

export const LoadingAlert = ({ text = 'Carregando...' }) => (
  <div className="alert alert-info flex items-center gap-3 mb-0">
    <Loading03Icon variant="duotone" size={20} className="animate-spin shrink-0" />
    <span>{text}</span>
  </div>
)
